import { useEffect, useState } from "react";

export const usePasswordValidation = ({
  firstPassword = "",
  secondPassword = "",
}) => {
  const [validLength, setValidLength] = useState(null);
  const [upperCase, setUpperCase] = useState(null);
  const [lowerCase, setLowerCase] = useState(null);
  const [specialChar, setSpecialChar] = useState(null);
  const [match, setMatch] = useState(null);
  const [numericChar, setNumericChar] = useState(null);

  useEffect(() => {
    setValidLength(firstPassword.length >= 10);
    setUpperCase(firstPassword.toLowerCase() !== firstPassword);
    setLowerCase(firstPassword.toUpperCase() !== firstPassword);
    setSpecialChar(/[ `!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(firstPassword));
    setNumericChar(/\d/.test(firstPassword));
    setMatch(firstPassword && firstPassword === secondPassword);
  }, [firstPassword, secondPassword]);

  return [lowerCase, match, specialChar, upperCase, validLength, numericChar];
};
